import { styled } from '@linaria/react'
import { BANNER_ASPECT_RATIO } from 'vars/banner-aspect-ratio'
import { BANNER_WIDTH } from 'vars/banner-width'
import { COLOR } from 'vars/color'

export const BannerSkeletonSC = styled.div<{
  aspectRatio: BANNER_ASPECT_RATIO
  bannerWidth: BANNER_WIDTH
}>`
  --width: ${({ bannerWidth }) =>
    `var(${bannerWidth || BANNER_WIDTH.SIZE_100})`};
  --aspectRatio: ${({ aspectRatio }) =>
    `var(${aspectRatio || BANNER_ASPECT_RATIO.SKELETON_DEFAULT})`};

  transition: transform 400ms linear;
  position: relative;
  overflow: hidden;

  background:
    var(${COLOR.SKELETON_SHINE_GRADIENT}),
    var(--componentsBGColor, rgba(37, 37, 37, 1));
  background-repeat: repeat-y;
  background-size: 800px 850px;
  background-position: -800px 0;

  animation: shine 1.5s infinite;
  @keyframes shine {
    to {
      background-position: calc(100vw + 1200px) 0;
    }
  }

  width: var(--width);
  height: calc(100vw / var(--aspectRatio));

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 72px;
    background: var(${COLOR.BANNER_SKELETON_BOTTOM_FADE});
    pointer-events: none;
  }
`
